import {CheckoutRequest, CheckoutResponse, createCheckout} from '@/api/marketplace';
import {useMutation} from '@tanstack/react-query';

export function useMarketplaceCheckout() {
    return useMutation<CheckoutResponse, Error, CheckoutRequest>({
        mutationFn: createCheckout
    });
}
